/**
 * Google Analytics 4 helper utilities
 * Measurement ID: G-PQ5X196PFY
 */

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export const GA_MEASUREMENT_IDS = ["G-PQ5X196PFY"] as const;

/** @deprecated Use GA_MEASUREMENT_IDS instead */
export const GA_MEASUREMENT_ID = GA_MEASUREMENT_IDS[0];

/**
 * Send a pageview event to all GA4 properties (for SPA route changes)
 */
export const trackPageView = (url: string, title?: string) => {
  if (typeof window.gtag !== "function") return;
  for (const id of GA_MEASUREMENT_IDS) {
    window.gtag("config", id, {
      page_path: url,
      page_title: title,
    });
  }
};

/**
 * Send a custom GA4 event
 */
export const trackGAEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>
) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
};

/**
 * Fire a Google Ads conversion event (lead form submission)
 */
export const trackGoogleAdsConversion = () => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: "AW-18029558200/a4i5CILdio0cELjzlJVD",
    value: 1.0,
    currency: "ILS",
  });
};
